import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import useAuthCheck from "./hooks/useAuthCheck";
import Login from "./pages/Login";
import Projects from "./pages/Projects";
import Teams from "./pages/Teams";

function App() {
    const authChecked = useAuthCheck();

    return !authChecked ? (
        <div className="text-center mt-[200px]">checking authentication...</div>
    ) : (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/"
                    element={
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/teams"
                    element={
                        <PrivateRoute>
                            <Teams />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/projects"
                    element={
                        <PrivateRoute>
                            <Projects />
                        </PrivateRoute>
                    }
                />
            </Routes>

            {/* react-toastify */}
            <ToastContainer />
        </BrowserRouter>
    );
}

export default App;
